module.exports = __webpack_public_path__ + "static/media/PSIO Vector Animated.a78e4e6e.svg";